<!-- ACTIVELY "For clubs" page. Two products, sequenced: get discovered & take
     visit requests (free listing), then run online bookings & operations (full
     system). Nav = <app-header>; footer = shared <app-footer> (AppComponent). -->
<div class="ap partner ap-in">
  <!-- ===== HERO ===== -->
  <section class="ap-hero">
    <div class="ap-hero__inner">
      <!-- LCP element: rendered visible immediately (no ap-reveal opacity fade)
           so the largest paint isn't gated behind an entrance animation. -->
      <h1>
        {{ 'partners.heroTitle' | translate }}<br /><span class="ap-accent">{{ 'partners.heroTitleAccent' | translate }}</span>
      </h1>
      <p class="ap-hero__sub">
        {{ 'partners.heroSub' | translate }}
      </p>

      <!-- Primary action: straight to club signup. No lead form — email and
           club name are collected by signup and the wizard anyway. -->
      <div class="partner-form ap-reveal" style="--ap-d: 180ms" #heroCta>
        <div class="partner-form__actions">
          <button
            class="ap-btn ap-btn--filled ap-btn--lg"
            type="button"
            (click)="startSignup('partners_hero')"
          >
            {{ 'partners.listClubFree' | translate }}
          </button>
          <button
            class="ap-btn ap-btn--plain ap-btn--lg"
            type="button"
            (click)="contact()"
          >
            {{ 'partners.talkToUs' | translate }}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
          </button>
        </div>

        <!-- Reassurance microcopy at the point of action: cost, lock-in, control. -->
        <p class="partner-form__note">
          {{ 'partners.formNote' | translate }}
        </p>
      </div>
    </div>
  </section>

  <!-- ===== GET STARTED (right after the hero: the simple 3-step path) ===== -->
  <section class="ap-section--gray ap-pad">
    <div class="ap-wrap">
      <div class="ap-section-head">
        <span class="ap-eyebrow">{{ 'partners.stepsEyebrow' | translate }}</span>
        <h2>{{ 'partners.stepsTitle' | translate }}</h2>
        <p>{{ 'partners.stepsSub' | translate }}</p>
      </div>
      <div class="ap-steps">
        <div class="ap-step ap-reveal">
          <span class="ap-step__icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
          </span>
          <p class="ap-step__n ap-mono">{{ 'partners.step1Num' | translate }}</p>
          <h3>{{ 'partners.step1Title' | translate }}</h3>
          <p>{{ 'partners.step1Desc' | translate }}</p>
        </div>
        <div class="ap-step ap-reveal" style="--ap-d: 80ms">
          <span class="ap-step__icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>
          </span>
          <p class="ap-step__n ap-mono">{{ 'partners.step2Num' | translate }}</p>
          <h3>{{ 'partners.step2Title' | translate }}</h3>
          <p>{{ 'partners.step2Desc' | translate }}</p>
        </div>
        <div class="ap-step ap-reveal" style="--ap-d: 160ms">
          <span class="ap-step__icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="16" rx="3" /><path d="M3 9h18M8 2.5v4m8-4v4" /></svg>
          </span>
          <p class="ap-step__n ap-mono">{{ 'partners.step3Num' | translate }}</p>
          <h3>{{ 'partners.step3Title' | translate }}</h3>
          <p>{{ 'partners.step3Desc' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== TWO-PRODUCT SECTION (sequenced: free now, paid later) ===== -->
  <section class="ap-pad" #featuresRef>
    <div class="ap-wrap">
      <div class="ap-section-head">
        <span class="ap-eyebrow">{{ 'partners.productsEyebrow' | translate }}</span>
        <h2>{{ 'partners.productsTitle' | translate }}</h2>
        <p>{{ 'partners.productsSub' | translate }}</p>
      </div>

      <div class="products">
        <!-- PRODUCT 1 — Get discovered & take visit requests. PRIMARY entry. -->
        <article class="product product--discovery product--primary ap-reveal">
          <div class="product__head">
            <span class="product__label ap-mono">{{ 'partners.product1Label' | translate }}</span>
            <span class="product__tag ap-mono">{{ 'partners.product1Tag' | translate }}</span>
          </div>
          <h3 class="product__title">{{ 'partners.product1Title' | translate }}</h3>
          <p class="product__desc">
            {{ 'partners.product1Desc' | translate }}
          </p>
          <ul class="product__list">
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product1Point1' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product1Point2' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product1Point3' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product1Point4' | translate }}
            </li>
          </ul>
          <button
            class="ap-btn ap-btn--filled product__cta"
            type="button"
            (click)="startSignup('partners_products')"
          >
            {{ 'partners.listClubFree' | translate }}
          </button>
        </article>

        <!-- PRODUCT 2 — Run online bookings & operations. SECONDARY, demoted. -->
        <article class="product product--operations product--secondary ap-reveal" style="--ap-d: 80ms">
          <span class="product__label ap-mono">{{ 'partners.product2Label' | translate }}</span>
          <h3 class="product__title">{{ 'partners.product2Title' | translate }}</h3>
          <p class="product__desc">
            {{ 'partners.product2Desc' | translate }}
          </p>
          <ul class="product__list">
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product2Point1' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product2Point2' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product2Point3' | translate }}
            </li>
            <li>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
              {{ 'partners.product2Point4' | translate }}
            </li>
          </ul>
          <button
            class="ap-btn ap-btn--tinted product__cta"
            type="button"
            (click)="contact()"
          >
            {{ 'partners.talkToUs' | translate }}
          </button>
        </article>
      </div>

      <p class="products__connect ap-reveal">
        <b>{{ 'partners.productsConnectBold' | translate }}</b> {{ 'partners.productsConnectRest' | translate }}
      </p>
    </div>
  </section>

  <!-- ===== FEATURES (what clubs get on the Actively network: profile,
       discovery, requests, control, reach — booking is the optional last one) ===== -->
  <section class="ap-section--gray ap-pad">
    <div class="ap-wrap">
      <div class="ap-section-head">
        <span class="ap-eyebrow">{{ 'partners.featuresEyebrow' | translate }}</span>
        <h2>{{ 'partners.featuresTitle' | translate }}</h2>
        <p>{{ 'partners.featuresSub' | translate }}</p>
      </div>

      <div class="features">
        <div class="feature ap-reveal">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2.5" /><path d="M8 8h8M8 12h8M8 16h5" /></svg>
          </span>
          <h3>{{ 'partners.feature1Title' | translate }}</h3>
          <p>{{ 'partners.feature1Desc' | translate }}</p>
        </div>
        <div class="feature ap-reveal" style="--ap-d: 60ms">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></svg>
          </span>
          <h3>{{ 'partners.feature2Title' | translate }}</h3>
          <p>{{ 'partners.feature2Desc' | translate }}</p>
        </div>
        <div class="feature ap-reveal" style="--ap-d: 120ms">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="m3.5 7 8.5 6 8.5-6" /></svg>
          </span>
          <h3>{{ 'partners.feature3Title' | translate }}</h3>
          <p>{{ 'partners.feature3Desc' | translate }}</p>
        </div>
        <div class="feature ap-reveal" style="--ap-d: 180ms">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 5 6v5c0 4.5 3 7.5 7 8.5 4-1 7-4 7-8.5V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg>
          </span>
          <h3>{{ 'partners.feature4Title' | translate }}</h3>
          <p>{{ 'partners.feature4Desc' | translate }}</p>
        </div>
        <div class="feature ap-reveal" style="--ap-d: 240ms">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18" /><path d="m7 14 3-3 3 3 5-5" /></svg>
          </span>
          <h3>{{ 'partners.feature5Title' | translate }}</h3>
          <p>{{ 'partners.feature5Desc' | translate }}</p>
        </div>
        <div class="feature ap-reveal" style="--ap-d: 300ms">
          <span class="feature__icon" aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="16" rx="3" /><path d="M3 9h18M8 2.5v4m8-4v4" /></svg>
          </span>
          <h3>{{ 'partners.feature6Title' | translate }}</h3>
          <p>{{ 'partners.feature6Desc' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== SOCIAL PROOF (only real proof = the 4 client logos) ===== -->
  <section class="ap-pad">
    <div class="ap-wrap">
      <div class="ap-section-head">
        <span class="ap-eyebrow">{{ 'partners.proofEyebrow' | translate }}</span>
        <h2>{{ 'partners.proofTitle' | translate }}</h2>
      </div>

      <div class="logos" [attr.aria-label]="'partners.proofLogosAria' | translate">
        <div class="logos__track">
          @for (client of marqueeClients; track $index) {
            <div class="logos__item">
              <img
                src="../../../assets/clients/{{ client.logo }}"
                [alt]="'partners.logoAlt' | translate:{ name: client.name }"
                loading="lazy"
              />
            </div>
          }
        </div>
      </div>

      <!-- Trust spike converts: a single primary CTA right after the logos. -->
      <div class="proof-cta">
        <button class="ap-btn ap-btn--filled ap-btn--lg" type="button" (click)="startSignup('partners_proof')">
          {{ 'partners.listClubFree' | translate }}
        </button>
      </div>
    </div>
  </section>


  <!-- ===== FAQ / OBJECTION HANDLING (cost, lock-in, control, mechanics) ===== -->
  <section class="ap-pad">
    <div class="ap-wrap">
      <div class="ap-section-head">
        <span class="ap-eyebrow">{{ 'partners.faqEyebrow' | translate }}</span>
        <h2>{{ 'partners.faqTitle' | translate }}</h2>
      </div>
      <ul class="faq">
        <li class="faq__item ap-reveal">
          <h3 class="faq__q">{{ 'partners.faq1Q' | translate }}</h3>
          <p class="faq__a">{{ 'partners.faq1A' | translate }}</p>
        </li>
        <li class="faq__item ap-reveal" style="--ap-d: 60ms">
          <h3 class="faq__q">{{ 'partners.faq2Q' | translate }}</h3>
          <p class="faq__a">
            {{ 'partners.faq2A' | translate }}
          </p>
        </li>
        <li class="faq__item ap-reveal" style="--ap-d: 120ms">
          <h3 class="faq__q">{{ 'partners.faq3Q' | translate }}</h3>
          <p class="faq__a">
            {{ 'partners.faq3A' | translate }}
          </p>
        </li>
        <li class="faq__item ap-reveal" style="--ap-d: 180ms">
          <h3 class="faq__q">{{ 'partners.faq4Q' | translate }}</h3>
          <p class="faq__a">
            {{ 'partners.faq4A' | translate }}
          </p>
        </li>
      </ul>
    </div>
  </section>

  <!-- ===== FINAL CTA BAND ===== -->
  <section class="ap-pad">
    <div class="ap-wrap">
      <div class="ap-owner">
        <div class="ap-owner__copy">
          <span class="ap-eyebrow">{{ 'partners.ctaEyebrow' | translate }}</span>
          <h2>{{ 'partners.ctaTitle' | translate }}</h2>
          <p>
            {{ 'partners.ctaSub' | translate }}
          </p>
          <div class="owner__actions">
            <button class="ap-btn ap-btn--filled ap-btn--lg" type="button" (click)="startSignup('partners_cta_band')">
              {{ 'partners.listClubFree' | translate }}
            </button>
            <button class="ap-btn ap-btn--plain ap-btn--lg" type="button" (click)="contact()">
              {{ 'partners.talkToUs' | translate }}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
            </button>
          </div>
        </div>
        <div class="owner__stats">
          <div class="owner__stat"><div class="num">{{ 'partners.statFreeNum' | translate }}</div><div class="lbl">{{ 'partners.statFreeLbl' | translate }}</div></div>
          <div class="owner__stat"><div class="num">24/7</div><div class="lbl">{{ 'partners.stat247Lbl' | translate }}</div></div>
          <div class="owner__stat"><div class="num">{{ 'partners.stat5minNum' | translate }}</div><div class="lbl">{{ 'partners.stat5minLbl' | translate }}</div></div>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== PERSISTENT FLOATING CTA (all viewports; shows once the hero form
       scrolls out of view, so the action is reachable at every scroll point) ===== -->
  <div
    class="partner-sticky"
    [class.is-visible]="showSticky"
    [attr.aria-hidden]="showSticky ? null : 'true'"
  >
    <button
      class="ap-btn ap-btn--filled"
      type="button"
      (click)="startSignup('partners_sticky')"
      [attr.tabindex]="showSticky ? null : -1"
    >
      {{ 'partners.listClubFree' | translate }}
    </button>
  </div>
  <!-- Footer is the shared <app-footer> (AppComponent) — do NOT add one here. -->
</div>
